export enum TrafficDashboardTabs {
  CHART = 'chart',
  TABLE = 'table',
}

export enum TrafficDashboardSearchParamKeys {
  VIEW = 'view',
}
